export const enum GroupSiteStatus {
    NotFound = 0, // Group site does not exist
    Provisioning = 1, // Group site is being provisioned: provisioning URL acquired and provisioning is under way
    Ready = 2, // Group site has been provisioned
    Error = 3, // There is an error during group site creation: error in server response, or max polling retry times were exceeded
}

export default GroupSiteStatus;
